<template>
    <div>

        <rkm-table
            :fields="fields"
            :items="data.model.procedimentos"
            hide-filters
            hide-pagination
        >

            <template v-slot:cell(codigo)="row">
                {{ row.item.fonte === 'abpg' ? row.item.codigo : formatProcedimento(row.item.codigo) }}
            </template>

            <template v-slot:cell(actions)="{ index }">

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Filters.
import formats from '@/filters/formats'

// Mixins.
import { repository } from '@/mixins'

export default {
    computed: {
        fields() {

            return [
                {
                    key: "codigo",
                    label: "Código",
                    class: "col-min",
                },
                {
                    key: "nome",
                    label: "Procedimento",
                },
                {
                    key: "actions",
                    label: "Ações",
                    class: "col-min",
                },
            ]
        },
        validations() {

            return {
                procedimento: {},
            }
        },
    },
    filters: {
        ...formats,
    },
    methods: {
        ...formats,
        destroy(index) {

            const destroy = async () => this.data.model.procedimentos.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o procedimento?', destroy)
        },
    },
    mixins: [repository],
    props: {
        data: { type: Object, required: true },
    }
}
</script>
